import { render, staticRenderFns } from "./footer-form.vue?vue&type=template&id=19d437d0&scoped=true"
import script from "./footer-form.vue?vue&type=script&lang=js"
export * from "./footer-form.vue?vue&type=script&lang=js"
import style0 from "./footer-form.vue?vue&type=style&index=0&id=19d437d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d437d0",
  null
  
)

export default component.exports